import React from 'react';
import { MessageSquareX } from 'lucide-react';

interface LoserMessageFieldProps {
  value: string;
  onChange: (value: string) => void;
}

const LoserMessageField: React.FC<LoserMessageFieldProps> = ({ value, onChange }) => {
  return (
    <div>
      <label className="flex items-center text-xs font-bold uppercase tracking-wider text-tinta mb-2">
        <MessageSquareX className="h-4 w-4 mr-2 text-tinta-soft" />
        Mensagem WhatsApp (Não Ganhou)
      </label>
      <p className="text-xs text-tinta-soft italic mb-2">
        Mensagem enviada via WhatsApp quando o lead não ganhar (opcional).
        Só será enviada se houver integração WhatsApp conectada.
      </p>
      <textarea
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Ex: Que pena! Desta vez não foi, mas não desista! Continue participando para ter novas chances de ganhar prêmios incríveis!"
        className="mt-1 block w-full bg-white border border-tinta/15 rounded-lg px-3 py-2.5 text-sm text-tinta placeholder:text-tinta-soft/70 placeholder:italic focus:outline-none focus:ring-2 focus:ring-bordo/40 focus:border-bordo transition-colors resize-y"
        rows={4}
        maxLength={1000}
      />
      <div className="flex justify-between mt-1">
        <p className="text-xs text-tinta-soft italic">
          Variáveis disponíveis: {'{nome}'}, {'{whatsapp}'}
        </p>
        <p className="text-xs text-tinta-soft italic">
          {value?.length || 0}/1000
        </p>
      </div>
    </div>
  );
};

export default LoserMessageField;
